import { useQuery } from '@tanstack/react-query';

import { HttpError } from '@/shared/api';

import { alertFeedApi, type LocationFeedSettings } from './alertFeedApi';
import { alertKeys } from './queryKeys';

/**
 * Пороги ленты точки (T-047). `null` в данных — сервер без ленты (404). Общий ключ
 * запроса у раздела «Лента точки» и у окна, решающего, показывать ли блок
 * «Для всей точки» (№12): запрос один.
 */
export function useLocationFeedSettings(location: string | null) {
  return useQuery({
    queryKey: alertKeys.settings(location ?? ''),
    enabled: location !== null,
    queryFn: async (): Promise<LocationFeedSettings | null> => {
      try {
        return await alertFeedApi.settings(location as string);
      } catch (error) {
        // Сервер старше T-047 — секции нет, ошибки на экране тоже.
        if (error instanceof HttpError && error.status === 404) return null;
        throw error;
      }
    },
    retry: false,
  });
}
